//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v11.1.0.0 (Newtonsoft.Json v13.0.0.0) (http://NJsonSchema.org)
// </auto-generated>
//----------------------







export enum ExType {
    Undefined = 0,
    Rule = 1,
    Explanation = 2,
    ExplanationVideo = 3,
    Exercise = 4,
    Test = 5,
    ManualApproval = 6,
    ModuleApproval = 7,
    Signature = 8,
    Survey = 9,
    Scorm = 10,
}